// 📄 utils/pathVariables.ts
// Path Variables tipo ":vendorId" dentro de endpoint.endpoint (ver
// ApiEndpointConfig en clienteConexionService.ts). Espejo exacto de
// functions/utils/pathVariables.js — no comparten runtime (frontend
// Webpack/TS vs Cloud Functions ESM), igual que construirUrlPreview
// (EndpointConfigCard.tsx) y construirUrlEjecucion (providers/ariba.js)
// ya están duplicadas por la misma razón. Cualquier cambio acá debe
// reflejarse también allá.
import { ApiEndpointParam } from "../services/clienteConexionService.ts";

const PATH_VARIABLE_REGEX = /:([A-Za-z_][A-Za-z0-9_]*)/g;

// Nombres únicos de path variables presentes en el path, en orden de
// aparición (ej. "/suppliers/:vendorId/:orderId" → ["vendorId", "orderId"]).
export const extraerNombresPathVariables = (path: string): string[] => {
  const nombres: string[] = [];
  const vistos = new Set<string>();
  let match: RegExpExecArray | null;
  const regex = new RegExp(PATH_VARIABLE_REGEX);
  while ((match = regex.exec(path || "")) !== null) {
    if (!vistos.has(match[1])) {
      vistos.add(match[1]);
      nombres.push(match[1]);
    }
  }
  return nombres;
};

const mapaValores = (pathVariables: ApiEndpointParam[]): Map<string, string> => {
  const mapa = new Map<string, string>();
  for (const v of pathVariables) {
    if (v.clave.trim()) mapa.set(v.clave.trim(), v.valor);
  }
  return mapa;
};

// Reemplaza cada ":nombre" por su valor (URL-encoded). Si no hay valor
// (o está vacío), deja el placeholder ":nombre" tal cual — así el texto
// resultante sigue mostrando qué falta completar en vez de romper la URL
// silenciosamente.
export const reemplazarPathVariables = (path: string, pathVariables: ApiEndpointParam[]): string => {
  const valores = mapaValores(pathVariables);
  return (path || "").replace(new RegExp(PATH_VARIABLE_REGEX), (match, nombre) => {
    const valor = valores.get(nombre);
    return valor && valor.trim() ? encodeURIComponent(valor.trim()) : match;
  });
};

// Nombres de path variables que aparecen en el path pero no tienen un
// valor (o vacío) en pathVariables — usado para bloquear el envío en
// AribaApiTester.tsx y para la validación espejo en el backend.
export const obtenerPathVariablesFaltantes = (path: string, pathVariables: ApiEndpointParam[]): string[] => {
  const valores = mapaValores(pathVariables);
  return extraerNombresPathVariables(path).filter((nombre) => {
    const valor = valores.get(nombre);
    return !valor || !valor.trim();
  });
};
